export const SET_API_BUSY  = 'SET_API_BUSY'
export const SET_API_ERROR = 'SET_API_ERROR'

// fetches all data types
export const FETCH_PRIORITY_DATA = 'FETCH_PRIORITY_DATA'
export const FETCH_DATA          = 'FETCH_DATA'
export const SET_COMPANY         = 'SET_COMPANY'

// ADMIN
export const FETCH_ADMIN  = 'FETCH_ADMIN'
export const CREATE_ADMIN = 'CREATE_ADMIN'
export const UPDATE_ADMIN = 'UPDATE_ADMIN'
export const DELETE_ADMIN = 'DELETE_ADMIN'
export const LOGOUT       = 'LOGOUT'

// ORDERS
export const SUBMIT_NEW_ORDER      = 'SUBMIT_NEW_ORDER'
export const REFRESH_ORDERS        = 'REFRESH_ORDERS'
export const REFRESH_OR_ADD_ORDERS = 'REFRESH_OR_ADD_ORDERS'
export const LOAD_NEW_ORDERS       = 'LOAD_NEW_ORDERS'
export const LOAD_ALL_ORDERS       = 'LOAD_ALL_ORDERS'
export const LOAD_ORDER            = 'LOAD_ORDER'
export const UPDATE_ORDER          = 'UPDATE_ORDER'
export const DELETE_ORDER          = 'DELETE_ORDER'
export const ARCHIVE_ORDER         = 'ARCHIVE_ORDER'
export const UNARCHIVE_ORDER       = 'UNARCHIVE_ORDER'
export const MARK_PRINTED_ORDERS   = 'MARK_PRINTED_ORDERS'
export const MARK_UNPRINTED_ORDERS = 'MARK_UNPRINTED_ORDERS'
export const VOID_ORDER            = 'VOID_ORDER'
export const UNVOID_ORDER          = 'UNVOID_ORDER'
export const UPDATE_ACCOUNT_NUMBER = 'UPDATE_ACCOUNT_NUMBER'

// CATALOG REQUESTS
export const UPDATE_CATALOG_REQUEST        = 'UPDATE_CATALOG_REQUEST'
export const DELETE_CATALOG_REQUEST        = 'DELETE_CATALOG_REQUEST'
export const MARK_PRINTED_CATALOG_REQUESTS = 'MARK_PRINTED_CATALOG_REQUESTS'

// DISCOUNTS
export const CREATE_DISCOUNT = 'CREATE_DISCOUNT'
export const UPDATE_DISCOUNT = 'UPDATE_DISCOUNT'
export const DELETE_DISCOUNT = 'DELETE_DISCOUNT'

// PAGES
export const FETCH_PAGES         = 'FETCH_PAGES'
export const CREATE_PAGE         = 'CREATE_PAGE'
export const SORT_PAGE           = 'SORT_PAGE'
export const UPDATE_PAGE         = 'UPDATE_PAGE'
export const REMOVE_PAGE_IMAGE   = 'REMOVE_PAGE_IMAGE'
export const DELETE_PAGE         = 'DELETE_PAGE'
export const CREATE_PAGE_CONTENT = 'CREATE_PAGE_CONTENT'
export const UPDATE_PAGE_CONTENT = 'UPDATE_PAGE_CONTENT'
export const SORT_PAGE_CONTENT   = 'SORT_PAGE_CONTENT'
export const DELETE_PAGE_CONTENT = 'DELETE_PAGE_CONTENT'

// PRODUCTS
export const CREATE_PRODUCT         = 'CREATE_PRODUCT'
export const UPDATE_PRODUCT         = 'UPDATE_PRODUCT'
export const DELETE_PRODUCT         = 'DELETE_PRODUCT'
export const UPDATE_PRODUCT_PRICING = 'UPDATE_PRODUCT_PRICING'
export const UPDATE_PRODUCT_LISTED  = 'UPDATE_PRODUCT_LISTED'

// PRODUCT LINKS
export const CREATE_PRODUCT_PART     = 'CREATE_PRODUCT_PART'
export const UPDATE_PRODUCT_PART     = 'UPDATE_PRODUCT_PART'
export const DELETE_PRODUCT_PART     = 'DELETE_PRODUCT_PART'
export const CREATE_PRODUCT_BUNDLE   = 'CREATE_PRODUCT_BUNDLE'
export const DELETE_PRODUCT_BUNDLE   = 'DELETE_PRODUCT_BUNDLE'
export const CREATE_PRODUCT_CATEGORY = 'CREATE_PRODUCT_CATEGORY'
export const DELETE_PRODUCT_CATEGORY = 'DELETE_PRODUCT_CATEGORY'
export const CREATE_PRODUCT_TAG      = 'CREATE_PRODUCT_TAG'
export const DELETE_PRODUCT_TAG      = 'DELETE_PRODUCT_TAG'
export const CREATE_PRODUCT_ITEM     = 'CREATE_PRODUCT_ITEM'
export const UPDATE_PRODUCT_ITEM     = 'UPDATE_PRODUCT_ITEM'
export const DELETE_PRODUCT_ITEM     = 'DELETE_PRODUCT_ITEM'

// BUNDLES
export const CREATE_BUNDLE       = 'CREATE_BUNDLE'
export const UPDATE_BUNDLE       = 'UPDATE_BUNDLE'
export const REMOVE_BUNDLE_IMAGE = 'REMOVE_BUNDLE_IMAGE'
export const DELETE_BUNDLE       = 'DELETE_BUNDLE'

// CATEGORIES
export const CREATE_CATEGORY = 'CREATE_CATEGORY'
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'

// TAGS
export const CREATE_TAG = 'CREATE_TAG'
export const UPDATE_TAG = 'UPDATE_TAG'
export const DELETE_TAG = 'DELETE_TAG'

// ITEMS
export const CREATE_ITEM       = 'CREATE_ITEM'
export const UPDATE_ITEM       = 'UPDATE_ITEM'
export const REMOVE_ITEM_IMAGE = 'REMOVE_ITEM_IMAGE'
export const DELETE_ITEM       = 'DELETE_ITEM'

// REFERRAL SOURCES
export const CREATE_REFERRAL_SOURCE = 'CREATE_REFERRAL_SOURCE'
export const UPDATE_REFERRAL_SOURCE = 'UPDATE_REFERRAL_SOURCE'
export const DELETE_REFERRAL_SOURCE = 'DELETE_REFERRAL_SOURCE'

// IMAGES
export const CREATE_IMAGE      = 'CREATE_IMAGE'
export const UPDATE_IMAGE      = 'UPDATE_IMAGE'
export const DELETE_IMAGE      = 'DELETE_IMAGE'
export const UPDATE_IMAGEABLES = 'UPDATE_IMAGEABLES'
export const CHECK_IMAGE_NAME  = 'CHECK_IMAGE_NAME'

// USERS
export const LOAD_ALL_USERS        = 'LOAD_ALL_USERS'
export const LOAD_USERS_PAGE       = 'LOAD_USERS_PAGE'
export const SEARCH_USERS          = 'SEARCH_USERS'
export const CREATE_USER           = 'CREATE_USER'
export const UPDATE_USER           = 'UPDATE_USER'
export const DELETE_USER           = 'DELETE_USER'
export const LOAD_USER             = 'LOAD_USER'
export const SET_PRIMARY_RECIPIENT = 'SET_PRIMARY_RECIPIENT'
export const CREATE_USER_RECIPIENT = 'CREATE_USER_RECIPIENT'
export const UPDATE_USER_RECIPIENT = 'UPDATE_USER_RECIPIENT'
export const DELETE_USER_RECIPIENT = 'DELETE_USER_RECIPIENT'

// MONTHS
export const UPDATE_MONTH = 'UPDATE_MONTH'

// REPORTS
export const SET_REPORT_COMPANY = 'SET_REPORT_COMPANY'
export const SET_REPORT_START   = 'SET_REPORT_START'
export const SET_REPORT_END     = 'SET_REPORT_END'



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/mutation-types.js
// module id = 3
// module chunks = 0